import { push } from 'connected-react-router'
import ja from 'date-fns/locale/ja'
import { addDays, format, isAfter, isSameDay } from 'date-fns'
import React, { FC, useMemo, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Layout } from 'components/Layout'
import { DeliveryOrderTemplate } from 'components/Templates'
import { TopHeadline } from 'components/Typography'
import { dateToString, parseToDate } from 'lib/helper'
import { State } from 'index'

const DeliveryOrder: FC = () => {
  const headingRef = useRef<HTMLHeadingElement>(null)
  const dispatch = useDispatch()
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const date = /\/order\/delivery\/.+/.test(pathname) ? pathname.split('/order/delivery/')[1] : undefined
  const currentDate = date ? parseToDate(date) : new Date()
  const isToday = isSameDay(currentDate, new Date())
  const isFuture = isAfter(currentDate, new Date())
  const headline = useMemo(() => `${format(currentDate, 'MM月dd日(E)', { locale: ja })}のお届け`, [currentDate])
  const handlePrevDate = () => {
    const prevDate = addDays(currentDate, -1)
    dispatch(push(`/order/delivery/${dateToString(prevDate)}`))
  }
  const handleNextDate = () => {
    const nextDate = addDays(currentDate, 1)
    dispatch(push(`/order/delivery/${dateToString(nextDate)}`))
  }

  return (
    <Layout
      customHeadline={
        <TopHeadline
          ref={headingRef}
          headline={headline}
          iconPath="/icon/white/schedule.svg"
          prevIcon={<img src="/icon/arrow_prev.svg" alt="前の日付へ" onClick={handlePrevDate} />}
          nextIcon={<img src="/icon/arrow_next.svg" alt="次の日付へ" onClick={handleNextDate} />}
          size="small"
        />
      }
      headingRef={headingRef}
      title={'取り寄せの注文を確認する'}
    >
      <DeliveryOrderTemplate currentDate={currentDate} date={date} isFuture={isFuture} isToday={isToday} />
    </Layout>
  )
}

export default DeliveryOrder
